import Chart from 'react-apexcharts'

function ApexChart({errors, warnings, infos, alerts, offs, rakes, errorsF, warningsF, infosF, alertsF, offsF, rakesF, isErrorsEmpty, isWarningsEmpty, isInfosEmpty, isAlertsEmpty, isOffsEmpty, isRakesEmpty}){
  
  let sumaErrors = 0;
  let sumaWarnings = 0;
  let sumaInfos = 0;
  let sumaAlerts = 0;
  let sumaOffs = 0;
  let sumaRakes = 0;

  let E = isErrorsEmpty ? [] : errorsF.length ? errorsF : errors
  let W = isWarningsEmpty ? [] : warningsF.length ? warningsF : warnings
  let I = isInfosEmpty ? [] : infosF.length ? infosF : infos
  let A = isAlertsEmpty ? [] : alertsF.length ? alertsF : alerts
  let O = isOffsEmpty ? [] : offsF.length ? offsF : offs
  let R = isRakesEmpty ? [] : rakesF.length ? rakesF : rakes


  E.forEach(err => sumaErrors+=err[4])
  W.forEach(war => sumaWarnings+=war[4])
  I.forEach(inf => sumaInfos+=inf[4])
  A.forEach(ale => sumaAlerts+=ale[4])
  O.forEach(off => sumaOffs+=off[4])
  R.forEach(rak => sumaRakes+=rak[4])  

 let state = {
   series: [{
     data: [sumaErrors, sumaWarnings, sumaInfos, sumaAlerts, sumaOffs, sumaRakes]
   }],
   options: {
     chart: {
       type: 'bar',
       height: 380
     },
     plotOptions: {
       bar: {
         barHeight: '100%',
         distributed: true,
         horizontal: true,
         dataLabels: {
           position: 'bottom'
         },
       }
     },
     colors: ['#d4526e', '#f48024', '#33b2df', '#2b908f', '#13d8aa', '#90ee7e'/* , '#546E7A', '#A5978B',  '#f9a3a4',  '#69d2e7' */
     ],
     dataLabels: {
       enabled: true,
       textAnchor: 'start',
       style: {
         colors: ['#000'],
         fontSize: '14px',
         fontFamily: 'Helvetica, Arial, sans-serif',
         fontWeight: 'normal'
       },
       formatter: function (val, opt) {
         return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val
       },
       offsetX: 0,
       dropShadow: {
         enabled: false
       }
     },
     stroke: {
       width: 1,
       colors: ['#fff']
     },
     xaxis: {
       categories: ['Errors', 'Warnings', 'Infos', 'Alerts', 'Offs', 'Rakes'],
     },
     yaxis: {
       labels: {
         show: false
       }
     },
     title: {
         text: 'IDENTIFICADORES',
         align: 'center',
         floating: true
     },
     subtitle: {
         text: 'Cantidad de Identificadores Detectados',
         align: 'center',
     },
     tooltip: {
       theme: 'dark',
       x: {
         show: false
       },
       y: {
         title: {
           formatter: function () {
             return ''
           }
         }
       }
     }
   },
 };

 return (
   <div id="chart" className="my-4">
     <Chart options={state.options} series={state.series} type="bar" height={380} />
   </div>
 )
}
export default ApexChart
   